import { groups } from "./usersAndGroups.js";

export const leaderboardActivityOptions = [
  { value: "calls", label: "Calls", type: "num" },
  { value: "sourced", label: "Sourced", type: "num" },
  { value: "messaged", label: "Messaged", type: "num", default: true },
  { value: "meetings", label: "Meetings", type: "num" },
  { value: "opens", label: "Opens", type: "%" },
  { value: "clicks", label: "Clicks", type: "%" },
  { value: "replies", label: "Replies", type: "%" },
  { value: "interested", label: "Interested", type: "%" },
];
export const leaderboardGroups = [
  ...groups,
  { value: "unassignedUsers", label: "No Group" },
];
